export default "__VITE_ASSET__t8dKHbt9__"